import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  VendorInput,
  VendorOption,
} from "../../../input/VendorInput/VendorInput";
import { VendorPresenceDataType } from "../types";

interface VendorConfigStepProps {
  columnName: string;
  dataType: string;
  selectedIds: number[];
  onColumnNameChange: (name: string) => void;
  onDataTypeChange: (dataType: string) => void;
  onSelectedIdsChange: (ids: number[]) => void;
}

export const VendorConfigStep: React.FC<VendorConfigStepProps> = ({
  columnName,
  dataType,
  selectedIds,
  onColumnNameChange,
  onDataTypeChange,
  onSelectedIdsChange,
}) => {
  const handleVendorsSelect = (vendors: VendorOption[]) => {
    const ids = vendors.map((vendor) => Number(vendor.value));
    onSelectedIdsChange(ids);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Configure Vendor Column
      </Typography>

      <Stack spacing={3}>
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Column Name
          </Typography>
          <TextField
            fullWidth
            value={columnName}
            onChange={(e) => onColumnNameChange(e.target.value)}
            placeholder="Enter column name"
            size="small"
          />
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Select Vendors
          </Typography>
          <VendorInput
            selectedVendorIds={selectedIds}
            onVendorsSelect={handleVendorsSelect}
          />
          {selectedIds.length > 0 && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              {selectedIds.length} vendor{selectedIds.length !== 1 ? "s" : ""}{" "}
              selected
            </Typography>
          )}
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Data Format
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              value={dataType}
              onChange={(e) => onDataTypeChange(e.target.value)}
            >
              <FormControlLabel
                value={VendorPresenceDataType.PRODUCT_COUNT}
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2">Product Count</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Shows the number of products installed from the selected
                      vendors
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value={VendorPresenceDataType.Y_N}
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2">Yes/No Format</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Shows "Yes" if any selected vendors have products
                      installed, "No" otherwise
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value={VendorPresenceDataType.ONE_ZERO}
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2">1/0 Binary Format</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Shows "1" if any selected vendors have products installed,
                      "0" otherwise
                    </Typography>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Stack>
    </Box>
  );
};
